import React from 'react';
import { UTCard, UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';
import Grid from '@material-ui/core/Grid';
import { string, func, bool, number } from 'prop-types';

import styles from './styles.module.scss';

const CardSlotContainer = ({ selected, onClick, id, beginsAt, endsAt }) => {
  const handleOnClick = () => onClick(id);
  return (
    <Grid item xs={12} md={4}>
      <UTTouchableWithoutFeedback className={styles.generalContainer} onClick={handleOnClick}>
        <UTCard className={`${styles.card} ${selected && styles.cardSelected}`} flat>
          <UTLabel extrabold darkGray className={selected && styles.labelSelected}>
            {beginsAt} - {endsAt}
          </UTLabel>
        </UTCard>
      </UTTouchableWithoutFeedback>
    </Grid>
  );
};

CardSlotContainer.propTypes = {
  selected: bool,
  onClick: func,
  id: number,
  beginsAt: string,
  endsAt: string
};

export default CardSlotContainer;
